"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLowestNodeIdIfMultiple = exports.updateArtifactSlug = exports.getAllInputDependencyNodesForNode = exports.getAllInputsForArtifact = exports.getDirectInputsForArtifact = exports.checkEdges = exports.getTargetNodes = exports.getSourceNodes = exports.getNodeById = exports.getTapeById = exports.getInputTapeIds = exports.isValidBaseField = void 0;
const common_1 = require("@finley-technologies/common");
const isValidBaseField = (params) => {
    const { baseFields, targetField, targetTypes } = params;
    const targetBaseField = baseFields.find(({ field }) => field === targetField);
    if (!targetBaseField) {
        return false;
    }
    return targetTypes.some((type) => targetBaseField.type === type);
};
exports.isValidBaseField = isValidBaseField;
const getInputTapeIds = ({ tapeId, graph, }) => {
    return graph.dataTapeDependencies
        .filter(({ outputArtifactId }) => outputArtifactId === tapeId)
        .map(({ inputArtifactId }) => inputArtifactId);
};
exports.getInputTapeIds = getInputTapeIds;
const getTapeById = ({ tapeId, graph, }) => {
    return graph.dataTapes.find(({ id }) => id === tapeId);
};
exports.getTapeById = getTapeById;
const getNodeById = ({ tapeBuilderNodeId, nodes, }) => {
    const filtered = nodes.filter(({ metadata }) => metadata.tapeBuilderNodeId === tapeBuilderNodeId);
    (0, common_1.finleyAssert)(filtered.length === 1, `found [${filtered.length}] nodes matching [id:${tapeBuilderNodeId}]`);
    return filtered[0];
};
exports.getNodeById = getNodeById;
const getSourceNodes = ({ node, graph, }) => {
    const { nodes, edges } = graph;
    const srcNodes = edges
        .filter(({ target }) => target === node.metadata.tapeBuilderNodeId)
        .map(({ source }) => (0, exports.getNodeById)({ tapeBuilderNodeId: source, nodes }));
    return srcNodes;
};
exports.getSourceNodes = getSourceNodes;
const getTargetNodes = ({ node, graph, }) => {
    const { nodes, edges } = graph;
    const targetNodes = edges
        .filter(({ source }) => source === node.metadata.tapeBuilderNodeId)
        .map(({ target }) => (0, exports.getNodeById)({ tapeBuilderNodeId: target, nodes }));
    return targetNodes;
};
exports.getTargetNodes = getTargetNodes;
// validates that the given node has given number of inputs and outputs.
// return an array of errors.
const checkEdges = ({ node, graph, isAllowedInputNode, minInputs, maxInputs, minOutputs, maxOutputs, getUINode, }) => {
    const errors = [];
    const friendlyName = getUINode(node).getFriendlyName(node);
    const inputNodes = (0, exports.getSourceNodes)({ node, graph });
    if (inputNodes.length < minInputs || inputNodes.length > maxInputs) {
        errors.push(`${friendlyName} node must have between ${minInputs} and ${maxInputs} input nodes. Found: ${inputNodes.length}`);
    }
    inputNodes.forEach((inputNode) => {
        const inputUiNode = getUINode(inputNode);
        if (!isAllowedInputNode(inputUiNode)) {
            const inputFriendlyName = inputUiNode.getFriendlyName(inputNode);
            errors.push(`${friendlyName} node cannot have ${inputFriendlyName} node as input`);
        }
    });
    const outputNodes = (0, exports.getTargetNodes)({ node, graph });
    if (outputNodes.length < minOutputs || outputNodes.length > maxOutputs) {
        errors.push(`${friendlyName} node must have between ${minOutputs} and ${maxOutputs} output nodes. Found: ${outputNodes.length}`);
    }
    return errors;
};
exports.checkEdges = checkEdges;
const getDirectInputsForArtifact = (params) => {
    const { targetArtifactId, dataTapes, dataTapeDependencies } = params;
    const graph = { dataTapes, dataTapeDependencies };
    const inputArtifactIds = (0, exports.getInputTapeIds)({ graph, tapeId: targetArtifactId });
    const inputArtifacts = inputArtifactIds.map((tapeId) => {
        const inputArtifact = (0, exports.getTapeById)({ graph, tapeId });
        (0, common_1.finleyAssert)(inputArtifact, `inputArtifact must exist for [tapeId:${tapeId}]`);
        return inputArtifact;
    });
    return inputArtifacts;
};
exports.getDirectInputsForArtifact = getDirectInputsForArtifact;
const getAllInputsForArtifact = (params) => {
    const { dataTapes, dataTapeDependencies } = params;
    const directInputs = (0, exports.getDirectInputsForArtifact)(params);
    const recursiveInputs = directInputs.flatMap((input) => (0, exports.getAllInputsForArtifact)({
        targetArtifactId: input.id,
        dataTapes,
        dataTapeDependencies,
    }));
    return Array.from(new Set([...directInputs, ...recursiveInputs]));
};
exports.getAllInputsForArtifact = getAllInputsForArtifact;
const getAllInputDependencyNodesForNode = (node, graph) => {
    const inputNodes = (0, exports.getSourceNodes)({ node, graph });
    return inputNodes.reduce((acc, inputNode) => {
        acc.push(inputNode);
        const inputNodesForInputNode = (0, exports.getSourceNodes)({
            node: inputNode,
            graph,
        });
        if (inputNodesForInputNode.length) {
            const inputNodesForInputNodeDependencies = (0, exports.getAllInputDependencyNodesForNode)(inputNode, graph);
            inputNodesForInputNodeDependencies.forEach((dependency) => {
                // prevent duplicate dependencies being added if graphs diverged and then remerged
                if (!acc.find(({ metadata: { tapeBuilderNodeId } }) => dependency.metadata.tapeBuilderNodeId === tapeBuilderNodeId)) {
                    acc.push(dependency);
                }
            });
        }
        return acc;
    }, []);
};
exports.getAllInputDependencyNodesForNode = getAllInputDependencyNodesForNode;
const updateArtifactSlug = (currentSlug, suggestedSerialNumber) => {
    const regex = /_[\da-f]{6,}$/;
    // If the current slug ends with and underscore followed by six or more hex digits
    if (regex.test(currentSlug)) {
        // Replace them
        return currentSlug.replace(regex, `_${suggestedSerialNumber}`);
    }
    // Else, append them
    return `${currentSlug}_${suggestedSerialNumber}`;
};
exports.updateArtifactSlug = updateArtifactSlug;
// sorts the nodes by their tapeBuilderNodeId and returns the lowest one.
// this is used by callers to pick a single stable node id among multiple nodes.
const getLowestNodeIdIfMultiple = (nodes) => {
    return nodes.length > 1
        ? nodes.map(({ metadata }) => metadata.tapeBuilderNodeId).sort()[0]
        : null;
};
exports.getLowestNodeIdIfMultiple = getLowestNodeIdIfMultiple;
//# sourceMappingURL=utils.js.map